import utils from '@/mixins/utils.js'
import { getQuantidadeExodontias } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Boolean} exibirOutrosProcedimentos Indica se o filtro de outros procedimentos está ativo.
 * @returns {Object}
 */
export function getDataFields(mes = null, exibirOutrosProcedimentos = false) {
  const colunaQuantidade = exibirOutrosProcedimentos
    ? 'Outros procedimentos'
    : 'Exodontias'

  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeExodontias(item, mes, exibirOutrosProcedimentos)
      },
    },
  }
}

export const infoHtml = ``
